import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { LeadAppLinkEntity } from '../../../entities/mdqx/leadapp/lead-app-link.entity';
import { LeadAppLinkActionTypes } from '../../actions/mdqx/lead-app-link.actions';
import { getLatestUpdatedAt } from '../../../helper/reducer.helper';

export const LEAD_APP_LINK_KEY = 'lead-app-link';

export interface LeadAppLinkState extends EntityState<LeadAppLinkEntity> {
    fetched: boolean;
    latestUpdatedAt: Date;
}

const adapter = createEntityAdapter<LeadAppLinkEntity>({
    selectId: (Entity) => Entity.Id,
});

const initialState = adapter.getInitialState({
    fetched: false,
    latestUpdatedAt: null,
});

export const leadAppLinkReducer = createReducer(
    initialState,
    on(LeadAppLinkActionTypes.GetSuccess, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setMany(Payload, { ...state, fetched: true, latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt })),
    on(LeadAppLinkActionTypes.AddSuccess, (state, { Payload }) => adapter.setOne(Payload, state)),
    on(LeadAppLinkActionTypes.LeadAppLinkCreateDataEntriesSuccess, (state, { Payload }) => adapter.setOne(Payload, state)),
    on(LeadAppLinkActionTypes.EditSuccess, (state, { Payload }) => adapter.setOne(Payload, state)),
    on(LeadAppLinkActionTypes.DeleteSuccess, (state, { Payload }) => adapter.removeOne(Payload, state)),
 );

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllLeadAppLinks = selectAll;
export const selectLeadAppLinkEntities = selectEntities;

export const selectLeadAppLinksFetched = (state: LeadAppLinkState) => state.fetched;
export const selectLeadAppLinksLatestUpdatedAt = (state: LeadAppLinkState) => state.latestUpdatedAt;
